import styled from "styled-components";
import { useDrag,useDrop, DragPreviewImage  } from 'react-dnd'

const FieldWrapper = styled.div`
  
  width:25%;
  
  padding:4px;
`

const StyledButton = styled.div`
  background: ${p=>p.theme.colors[p.color]};
  padding:5px 15px;
  border: 1px solid ${p=>p.theme.colors.border[p.color]};
  color: ${p=>p.theme.colors.on[p.color]};
  border-radius: 4px;
  cursor: grab;
  height:60px;
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius: 40px;
  
`

const ComponentType = styled.div`
    font-size:0.6rem;
    font-weight:bold;
    text-transform:uppercase;
    font-family: 'Open Sans'
`

const ComponentName = styled.div`
`

const CRUDButton = props => {

    const { color, name, action, id, registerId } = props;


    const [{ isDragging }, drag, _preview] = useDrag(() => ({
        type: 'component',
        item: { 
            action: 'create', 
            type: 'CRUD', 
            name,
            defaultExtra : {
                color,
                action,
                type: 'register',
                registerId,
                idField: 'queryParams._id'
            }
        },
        collect: monitor => ({
          isDragging: !!monitor.isDragging(),
        }),
      }))

      
    
    
      return (
            <FieldWrapper ref={drag}><StyledButton color={color}><ComponentName>{name}</ComponentName></StyledButton></FieldWrapper>
      );

}

export default CRUDButton